var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"RkmForm"},[_c('rkm-row',_vm._l((_vm.salas),function(sala){return _c('rkm-col',{key:sala.id},[_c('rkm-button',{staticClass:"big-button",attrs:{"block":"","color":"primary"},on:{"click":function($event){return _vm.handleStore(sala)}}},[_vm._v(" "+_vm._s(sala.nome)+" ")])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }